module.exports = __webpack_public_path__ + "img/intro_content.701fee43.jpg";